
import { defineComponent, onMounted, reactive } from 'vue'

// @components
import NewTable from '@/common/new-components/NewTable/index.vue'
import NewButton from '@/ui-kit/NewButton/index.vue'
import Loader from '@/common/components/UI/Loader/index.vue'
import NewLimit from '@/common/new-components/NewLimit/index.vue'
import NewPagination from '@/common/new-components/NewPagination/index.vue'

// @module components
import CrmCustomersFilters from '@/modules/CrmModule/components/CrmCustomersFilters/index.vue'
import CustomersRow from '@/modules/CrmModule/components/CustomersRow/index.vue'

// @types
import { Customer, GetCustomersParams } from '@/new-services/types/crm'

// @new-services
import crmAPI from '@/new-services/crm.service'

// @composable

const TABLE_COLUMNS = [
    {
        key: 'operatorEmail',
        name: 'Оператор',
    },
    {
        key: 'count',
        name: 'Отправлено в AmoCRM',
    },
]

export default defineComponent({
    components: {
        CrmCustomersFilters,
        CustomersRow,
        NewTable,
        NewButton,
        Loader,
        NewLimit,
        NewPagination,
    },
    setup() {
        const state = reactive({
            list: [] as Customer[],
            is_excel_loading: false,
            is_loading: false,
            is_failed: false,
            filters: {
                operatorEmail: null as string | null,
                periodFrom: null as string | null,
                periodTo: null as string | null,
            },
            pagination: {
                page: 1,
                limit: 50,
                total_pages: 1,
                total_items: 20,
            },
        })

        //

        const loadCustomers = async () => {
            try {
                state.is_loading = true

                const params: GetCustomersParams = {
                    page: state.pagination.page,
                    limit: state.pagination.limit,
                    ...state.filters,
                }

                const response = await crmAPI.getCustomers(params)
                state.list = response.data.data
                // state.pagination.total_items = response.data.meta.total
                // state.pagination.total_pages = response.data.meta.last_page

                state.is_failed = false
            } catch (error) {
                state.is_failed = true
                console.error(error)
            } finally {
                state.is_loading = false
            }
        }

        const onFiltersChanged = (filters: GetCustomersParams) => {
            state.filters.operatorEmail = filters.operatorEmail
            state.filters.periodFrom = filters.periodFrom
            state.filters.periodTo = filters.periodTo

            loadCustomers()
        }

        const onFiltersReset = () => {
            state.filters.operatorEmail = null
            state.filters.periodFrom = null
            state.filters.periodTo = null

            loadCustomers()
        }

        const onLimitChange = (new_limit: number) => {
            state.pagination.limit = new_limit
            loadCustomers()
        }

        const onChangePage = (new_page: number) => {
            state.pagination.page = new_page
            loadCustomers()
        }

        //

        onMounted(loadCustomers)

        //

        return {
            state,
            //
            onFiltersChanged,
            onFiltersReset,
            onLimitChange,
            onChangePage,
            loadCustomers,
            //
            TABLE_COLUMNS,
        }
    },
})
